import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import { METADATA } from '../../constants';
import Navbar from '../../components/HomeComponents/Navbar';
// import Footer from '../../components/HomeComponents/Footer';
import SectionOne from '../../components/HomeComponents/Kontakt/SectionOne/index';
import SectionTwo from '../../components/HomeComponents/Kontakt/SectionTwo';
import SectionThree from '../../components/HomeComponents/Kontakt/SectionThree';
import SectionFour from '../../components/HomeComponents/Sections/SectionFour';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  // sectionOne: {
  //   height: "500px",
  //   backgroundColor: "#e1eff6",
  // },
}));


export default function Kontakt() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content={METADATA.KONTAKT.description} />
        <title>{METADATA.KONTAKT.title}</title>
      </Helmet>
      <Navbar />
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
      {/* <Footer /> */}
    </div>
  )
}